import { ChatMessageIn, ChatMessageOut } from "./index";
import { MessageUI } from "./types";

/**
 * 對話頁面主體
 * 顯示對話內容
 */
export function ConversationMain({
  messages,
  messagesEndRef,
}: {
  messages: MessageUI[];
  messagesEndRef: React.RefObject<HTMLDivElement>;
}) {
  return (
    <>
      <main className="chat-container viewport-height flex flex-col">
        <div className="flex-1 pr-4 pl-4 overflow-y-auto space-y-3 md:space-y-4 h-full pb-20 md:pb-24 max-w-7xl mx-auto w-full">
          <div className="flex-1 overflow-hidden relative">
            <div className="h-full overflow-y-auto py-4 px-4 md:px-6 pb-12 space-y-2">
              {messages.map((message) => (
                <div
                  key={message.id}
                  className={`flex ${message.sender === "user" ? "justify-end animate-slide-down" : "justify-start animate-slide-down"}`}
                >
                  {message.sender === "ai" ? (
                    <ChatMessageOut message={message} />
                  ) : (
                    <ChatMessageIn message={message} />
                  )}
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
